import * as XLSX from 'xlsx';
import { renderDate } from 'common/services/util';
import { mapPaymentMode } from './config';

const exportInvoicesExcelUseCase = async (data, clients) => {
    const dataToExport = data.map(row => {
        const dni = row.dniClient
        const codClient = clients?.[dni]?.codClient || ""

        return {
            "Nº Factura": String(row.numInvoice),
            "Cliente": row.nameClient,
            "Cod. cliente": codClient,
            "NIF": row.dniClient,
            "Fecha": renderDate(row.invoiceDate),
            "Total": row.totalPrice,
            "Base imponible": row.basePrice,
            "IVA": (row.totalPrice || 0) - (row.basePrice || 0),
            "Porcentaje IVA": row.ivaPercent ? parseFloat(row.ivaPercent) : 21,
            "Pagado": row.payed ? "Si" : "No",
            "Fecha de pago": renderDate(row.payedDate),
            "Forma de pago": mapPaymentMode[row.paymentMode] || ""
        }
    })

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const columnWidths = [
        { wpx: 100 }, { wpx: 150 }, { wpx: 100 }, { wpx: 150 },
        { wpx: 100 }, { wpx: 150 }, { wpx: 100 }, { wpx: 150 },
        { wpx: 100 } 
      ];
  
    ws['!cols'] = columnWidths;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Facturas');
    XLSX.writeFile(wb, "Facturas.xlsx"); 
}

export default exportInvoicesExcelUseCase